import { Suspense, useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { FiltrosComponent } from '../components/filtrosComponent';
import { TablaComponent } from '../components/tablaComponent';
import { FormFiltersInterface } from '../interfaces/FormFiltersInterface';
import { breadcrumbItems } from '../utils/BreadcrumbItems';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import { selectorTransversal } from '../../../../dtos/selector';
import { obtenerEmpresasCobranza } from '../services/morososServinco';
import { McmEmpresaCobranza } from '../models/respuestaMorososServinco';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';
import { AxiosResponse } from 'axios';

const actualYear = new Date().getFullYear();

function MorososServinco() {
    const [empresasCobranza, setEmpresasCobranza] = useState<selectorTransversal[]>([]);
    const [formFilters, setFormFilters] = useState<FormFiltersInterface & { trigger: number }>(
        { rutDeudor: null, nombreDeudor: null, numeroOperacion: actualYear.toString(), rutEmisor: null, isAdmin: true, trigger: 0 }
    );

    const handleFilter = (formFilters: FormFiltersInterface) => setFormFilters(prev => ({...formFilters, trigger: prev.trigger + 1}));

    const getEmpresasCobranza = async () => {
        const resp: AxiosResponse<ListResponseDto<McmEmpresaCobranza>> = await obtenerEmpresasCobranza();

        if(resp.status === 200){
            const options = resp.data.items.map((e: McmEmpresaCobranza) => ({
                label: e.empresaCobranza,
                value: e.idEmpresa,
            }));
            setEmpresasCobranza(options);
        }
    };

    useEffect(() => {
        getEmpresasCobranza();
    }, []);

    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems } />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>

                            <FiltrosComponent handleFilter={handleFilter} />

                            <TablaComponent
                                key={formFilters.trigger}
                                form={formFilters}
                                optionsEmpresaCobranza={empresasCobranza}
                            />

                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
};

export default MorososServinco;